import FORGEROCK_ACTION_TYPES from '../actionTypes/ForgeRock';
import VEHICLE_CAPABLE_ACTION from '../actionTypes/VehicleCapable';
import { QRVALUE_ACTION_TYPES } from '../actionTypes';
import SUBSCRIPTION_ACTION from '../actionTypes/Subscriptions';

// reducer with initial state
const initialState = {
  forgerock_loading: false,
  forgerock_error: null,
  forgerock_Value: '',
};

const forgerockReducer = (state = initialState, action) => {
  switch (action.type) {
    case FORGEROCK_ACTION_TYPES.IN_PROGRESS:
      return { ...state, forgerock_loading: true, forgerock_error: null };
    case FORGEROCK_ACTION_TYPES.AUTHORIZED_SUCCESS:
      return { ...state, forgerock_loading: false, forgerock_Value: action.payload };
    case FORGEROCK_ACTION_TYPES.ERROR:
      return {
        ...state,
        forgerock_loading: false,
        forgerock_Value: null,
        forgerock_error: action.error,
      };
    case VEHICLE_CAPABLE_ACTION.VEHICLE_CAPABLE_ERROR:
    case QRVALUE_ACTION_TYPES.POST.SUCCESS:
    case SUBSCRIPTION_ACTION.SUBSCRIPTION_ERROR:
      return { ...state, forgerock_Value: '' };
    default:
      return state; // return initial state by default
  }
};

export default forgerockReducer;
